import {Device} from 'epic-fortnite-styles/constants';
import styled from 'styled-components';

const MobileSubTitle = styled.h1`
  &&& {
    color: black;
    letter-spacing: 10px;
    margin: 0;
    font-size: 1.4em;
    line-height: 1;
    display: none;
    font-style: italic;
    @media screen and ${Device.mobileL} {
      display: inline;
      font-size: 2em;
      margin-top: 0.5em;
      letter-spacing: 0.2em;
    }
    @media screen and ${Device.mobileL} {
      font-size: 1.2em;
      margin-top: 0.7em;
      letter-spacing: 0.1em;
    }
  }
`;

export default MobileSubTitle;
